import type { ClassificationCategory } from '@repo/api-gw-sdk';
import { useMemo } from 'react';

import { useDAL } from '@/contexts/useDAL';

export const useClassificationCategories = () => {
  const dal = useDAL();
  const { data, isLoading } = dal.inventory.dataClasses.useCategories();

  const categories = useMemo<ClassificationCategory[]>(
    () => data?.categories ?? [],
    [data?.categories]
  );

  const lookup = useMemo<Record<string, ClassificationCategory>>(
    () => Object.fromEntries(categories.map((c) => [c.name, c])),
    [categories]
  );

  return { categories, lookup, isLoading };
};

export const useDataClassFilterOptions = () => {
  const { categories, isLoading } = useClassificationCategories();
  const options = useMemo(
    () =>
      categories.map((c) => ({
        id: c.name,
        name: c.name,
        description: c.description,
      })),
    [categories]
  );
  return { options, isLoading };
};
